import { useQuery } from '@tanstack/react-query';

import { fetchEmployeeFilterOptions } from '../api/fetchCompanyFilters';

export function useCompanyFilters(shouldFetch?: boolean) {
  const { data, isLoading } = useQuery({
    queryKey: ['employee-filter-options'],
    queryFn: fetchEmployeeFilterOptions,
    enabled: shouldFetch
  });

  return { companies: data?.companies, loading: isLoading };
}
